import { Platform } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { createClient } from "@supabase/supabase-js";
import "react-native-url-polyfill/auto";
import { getSupabaseUrl } from "./constants";

const WebStorageAdapter = {
  getItem: (key: string) => AsyncStorage.getItem(key),
  setItem: (key: string, value: string) => AsyncStorage.setItem(key, value),
  removeItem: (key: string) => AsyncStorage.removeItem(key),
};

let _supabase: ReturnType<typeof createClient> | null = null;

export const supabase = new Proxy({} as ReturnType<typeof createClient>, {
  get(_target, prop) {
    if (!_supabase) {
      _supabase = createClient(
        getSupabaseUrl(),
        process.env.EXPO_PUBLIC_SUPABASE_KEY ?? "",
        {
          auth: {
            ...(Platform.OS !== "web" ? { storage: WebStorageAdapter } : {}),
            autoRefreshToken: true,
            persistSession: true,
            detectSessionInUrl: false,
          },
        }
      );
    }
    return (_supabase as unknown as Record<string | symbol, unknown>)[prop];
  },
});

export type TypedSupabaseClient = typeof supabase;
